export default {"src":"/_next/static/media/mobile.6d601f73.svg","height":22,"width":15,"blurWidth":0,"blurHeight":0};